import { axiosGet, axiosPatch } from "../axios/axios.config";

export const getTenantData = async (data) => {
  const response = await axiosGet(`data/api/types/tenant/${data}`, {});
  return response;
};

export const updateTenantData = async (id, data) => {
  const response = await axiosPatch(`data/api/types/tenant/${id}`, data);
  return response;
};
